import { Providers } from '@microsoft/esign.gateway.service.client';
import { ApprovalRequestType } from '../data/types.generated';
import { getAppHost } from './TeamsUtils';

export const getProviderNameLocale = (approvalType: ApprovalRequestType): string => {
    const loc = getAppHost().getLocale();
    const m = {
        [ApprovalRequestType.ESign]: loc.strings.adobe_sign_name,
        [ApprovalRequestType.Docusign]: loc.strings.docusign_name,
    };

    return m[approvalType];
};

export const getEsignGatewayApiName = (url: string): string => {
    const regex = /\/esign-gateway\/([a-zA-Z]+)\/([a-zA-Z]+)\//;
    const matchedUrl = url.match(regex);
    const apiName = matchedUrl ? matchedUrl[0].toString() : url;
    return apiName;
};

export const getEsignGatewayProvider = (approvalRequestType: ApprovalRequestType): string => {
    switch (approvalRequestType) {
        case ApprovalRequestType.ESign:
            return Providers.Adobe;
        case ApprovalRequestType.Docusign:
            return Providers.DocuSign;
        case ApprovalRequestType.Syntex:
            return Providers.Syntex;
        default:
            return null;
    }
};

export enum SharePointESignStatus {
    Processing = 'Processing',
    Pending = 'Pending',
    PendingCompletion = 'PendingCompletion',
    Completed = 'Completed',
    Declined = 'Declined',
    Canceling = 'Canceling',
    Canceled = 'Canceled',
    Expired = 'Expired',
}
